// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__lPBmZ","checkmark":"Checkbox_checkmark__H3nN5"};